// @ts-nocheck
// Completely stolen from cls-rtracer source code
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_EMAIL_HEADER = exports.SESSION_HEADER = exports.requestIDFactory = exports.REQUEST_HEADER = exports.wrapEmitter = void 0;
const nanoid_1 = require("nanoid");
const isWrappedSymbol = Symbol('cls-rtracer-is-wrapped');
const wrappedSymbol = Symbol('cls-rtracer-wrapped-function');
function wrapEmitterMethod(emitter, method, wrapper) {
    if (emitter[method][isWrappedSymbol]) {
        return;
    }
    const original = emitter[method];
    const wrapped = wrapper(original, method);
    wrapped[isWrappedSymbol] = true;
    emitter[method] = wrapped;
    return wrapped;
}
const addMethods = ['on', 'addListener', 'prependListener'];
const removeMethods = ['off', 'removeListener'];
/**
 * Wraps EventEmitter listener registration methods of the
 * given emitter, so that all listeners are run in scope of
 * the provided async resource.
 */
function wrapEmitter(emitter, asyncResource) {
    for (const method of addMethods) {
        wrapEmitterMethod(emitter, method, (original) => function (name, handler) {
            handler[wrappedSymbol] = asyncResource.runInAsyncScope.bind(asyncResource, handler, emitter);
            return original.call(this, name, handler[wrappedSymbol]);
        });
    }
    for (const method of removeMethods) {
        wrapEmitterMethod(emitter, method, (original) => function (name, handler) {
            return original.call(this, name, handler[wrappedSymbol] || handler);
        });
    }
}
exports.wrapEmitter = wrapEmitter;
exports.REQUEST_HEADER = 'x-request-id';
const requestIDFactory = () => (0, nanoid_1.nanoid)();
exports.requestIDFactory = requestIDFactory;
exports.SESSION_HEADER = 'x-session-id';
exports.USER_EMAIL_HEADER = 'x-user-email';
//# sourceMappingURL=util.js.map